<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("love.menu.google_reviews") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <p class="ct-text">
                    {{ $t("love.google_reviews.title") }}
                </p>
                <FormSwitch :options="options" v-model="chosenOption" />
                <template v-if="chosenOption === SEARCH_OPTIONS.byQuery">
                    <FormInputPreIcon
                        icon="MagnifyingGlassIcon"
                        :title="$t('love.google_reviews.search_place')"
                        :placeholder="$t('love.google_reviews.search_place_placeholder')"
                        v-model="googleQuery"
                        @keyup.enter="handleSearchPlaces()"
                    />
                    <ButtonPrimaryMd
                        :disabled="!canSearch"
                        @click="handleSearchPlaces()"
                        class="w-full"
                    >
                        {{ $t("love.google_reviews.search_place_cta") }}
                    </ButtonPrimaryMd>
                </template>
                <template v-if="chosenOption === SEARCH_OPTIONS.byPlaceId">
                    <FormInput
                        :title="$t('love.google_reviews.provide_place_id')"
                        placeholder="ChIJJwXJYmctGUcRSIo6_AKuEZo"
                        v-model="placeIdToSearch"
                        @keyup.enter="handleSearchByPlaceId()"
                    />
                    <ButtonPrimaryMd
                        @click="handleSearchByPlaceId()"
                        class="w-full"
                        :disabled="!placeIdToSearch"
                    >
                        {{ $t("love.google_reviews.search_by_place_id_cta") }}
                    </ButtonPrimaryMd>
                </template>
                <p v-if="searchDone && resultsLength === 0" class="text-sm font-medium ct-text-1">
                    {{ $t("love.google_reviews.no_results") }} “{{ lastSearch }}”.
                    {{ $t("love.google_reviews.try_another") }}
                </p>
                <div v-if="searchDone" class="space-y-2.5">
                    <p class="text-sm font-medium ct-text-1">
                        {{ $t("love.google_reviews.found") }} {{ resultsLength }}
                        {{ $t("love.google_reviews.results_for") }} “{{ lastSearch }}”
                    </p>
                    <CardHover
                        v-for="item in googlePlaces"
                        :key="item.place_id"
                        @click="$emit('chosePlace', item)"
                    >
                        <p class="font-medium ct-text-1">{{ item.name }}</p>
                        <p class="truncate ct-text-2">{{ item.address }}</p>
                        <p class="mt-2 ct-text">
                            {{ $t("love.google_reviews.average_rating") }} ({{ item.rating }}) ·
                            {{ item.reviews }} {{ $t("love.google_reviews.reviews") }}
                        </p>
                    </CardHover>
                </div>
            </div>
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { FormInput, FormInputPreIcon, FormSwitch } from "@easy/ui/forms";
import { ButtonPrimaryMd } from "@easy/ui/buttons";
import { CardHover } from "@easy/ui/cards";
import { googleService } from "@/apps/love/services/google.service";
import { t } from "@/i18n";

const SEARCH_OPTIONS = {
    byQuery: "by-query",
    byPlaceId: "by-place-id",
};

export default {
    components: {
        FormSwitch,
        ButtonPrimaryMd,
        CardHover,
        FormInput,
        FormInputPreIcon,
        PageSidebar,
    },
    emits: ["chosePlace", "placeIdProvided"],
    setup() {
        return { SEARCH_OPTIONS };
    },
    data() {
        return {
            googleQuery: "",
            lastSearch: "",
            searchDone: false,
            googlePlaces: [],
            placeIdToSearch: "",
            chosenOption: SEARCH_OPTIONS.byQuery,
        };
    },
    computed: {
        options() {
            return [
                { value: SEARCH_OPTIONS.byQuery, label: t("love.google_reviews.search_by_query") },
                {
                    value: SEARCH_OPTIONS.byPlaceId,
                    label: t("love.google_reviews.search_by_place_id"),
                },
            ];
        },
        canSearch() {
            const isSearchDistinct = this.lastSearch !== this.googleQuery;
            return Boolean(this.googleQuery) && isSearchDistinct;
        },
        resultsLength() {
            return this.googlePlaces.length;
        },
    },
    methods: {
        async handleSearchPlaces() {
            if (!this.canSearch) {
                return;
            }
            try {
                this.googlePlaces = await googleService.findGooglePlace({
                    query: this.googleQuery,
                });
                this.lastSearch = this.googleQuery;
                this.searchDone = true;
            } catch {
                //empty
            }
        },
        async handleSearchByPlaceId() {
            if (this.placeIdToSearch) {
                this.$emit("placeIdProvided", this.placeIdToSearch);
                this.placeIdToSearch = "";
            }
        },
    },
};
</script>
